<template>
    <div
        v-qa="'grid-content-loader'"
        class="grid-content-loader"
    >
        <loading-animation />
    </div>
</template>

<script setup lang="ts">
import LoadingAnimation from '@/components/ui/LoadingAnimation.vue'
</script>

<style lang="scss" scoped>
.grid-content-loader {
    width: 100%;
    height: 300px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
}
</style>
